import { Phone, MessageCircle } from "lucide-react";
import { telHref, waHref, PHONE } from "@/constants/site";
import useCallTracking from "@/hooks/useCallTracking";
import useEventTracking from "@/hooks/useEventTracking";
import { useT } from "@/i18n/LanguageContext";

/**
 * Always-visible Call + WhatsApp bar fixed to the bottom of the viewport on mobile.
 * Hidden on desktop (lg and up). Adds safe-area padding for iPhones.
 */
export default function MobileStickyBar() {
  const trackCall = useCallTracking();
  const trackEvent = useEventTracking();
  const { t } = useT();

  return (
    <div
      data-testid="mobile-sticky-bar"
      className="lg:hidden fixed bottom-0 left-0 z-50 pl-3 pb-3 pt-2"
      style={{ paddingBottom: "calc(3.25rem + env(safe-area-inset-bottom))" }}
    >
      <div className="flex items-center gap-2 bg-[#0A0A0A] rounded-full p-1.5 shadow-[0_10px_30px_-10px_rgba(0,0,0,0.5)] border border-white/10 w-max">
        <a
          data-testid="mobile-sticky-call"
          href={telHref}
          onClick={trackCall("mobile-sticky")}
          aria-label={`${t.nav.call} ${PHONE}`}
          className="h-12 w-12 rounded-full inline-flex items-center justify-center bg-[#1E63FF] text-white active:scale-[0.95] transition-transform pulse-blue shrink-0"
        >
          <Phone className="w-5 h-5" strokeWidth={2.2} />
        </a>
        <a
          data-testid="mobile-sticky-whatsapp"
          href={waHref()}
          target="_blank"
          rel="noopener noreferrer"
          onClick={trackEvent("whatsapp", "mobile-sticky")}
          aria-label="WhatsApp TyresPro"
          className="h-12 w-12 rounded-full inline-flex items-center justify-center bg-[#25D366] text-white active:scale-[0.95] transition-transform shrink-0"
        >
          <MessageCircle className="w-5 h-5" strokeWidth={2.2} />
        </a>
      </div>
    </div>
  );
}
